import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../WellLoggingOperations/types';

export const Breadcrumbs: FC = () => {
    const { activeGroupKey, data } = useSelector((state: RootState) => state.lists);
    const { userProfiles, activeUserProfile } = useSelector((store: RootState) => store.geoTest);

    const activeGroup = data?.find(({ key }) => key === activeGroupKey);
    
    const profile = userProfiles.find(({ id }) => activeUserProfile === id);

    return (
        <div className="flex h-6 items-center justify-between border-b border-solid border-gray-500 bg-white px-4 py-1 text-xxs text-gray-800 dark:border-fill-primary dark:bg-fill-quarternary dark:text-font-secondary">
            <div className="w-1/2 truncate">
                {activeGroup ? (
                    `${activeGroup?.title} / `
                ) : (
                    <span className="text-gray-800 dark:text-font-primary">
                        {profile ? `${profile.profileName} /` : null}
                    </span>
                )}
            </div>
        </div>
    );
};
